import { render, staticRenderFns } from "./cirurgia-conjunta.vue?vue&type=template&id=db4dae0c&scoped=true"
import script from "./cirurgia-conjunta.vue?vue&type=script&lang=ts"
export * from "./cirurgia-conjunta.vue?vue&type=script&lang=ts"
import style0 from "./cirurgia-conjunta.vue?vue&type=style&index=0&id=db4dae0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4dae0c",
  null
  
)

export default component.exports